module.exports = __webpack_public_path__ + "img/kc14.cc0c9c0c.png";